import React, { useEffect, useState } from "react";
import { Button, Card, Form, Spinner } from "react-bootstrap";
import backBtn from "../../assets/icons/arrow_left.svg";
import { api } from "../../helpers/apiCore";
import { endpoints } from "../../helpers/Endpoints";
import mastercardImg from "../../assets/images/mastercard.svg";
import moment from "moment";
import UserWalletActivities from "./UserWalletActivities";
import DebitWallet from "./DebitWallet";

export interface User {
	_id: string,
	firstName: string,
	lastName: string,
	email: string,
	userType: string | any,
	phoneNumber: string,
	institution: string,
	department: string,
	createdAt: string,
};

export interface Wallet {
	user: User | null,
	_id: string,
	walletId: string,
	balance: number | any,
	commission: number,
	status: string,
	userType: string | any,
	totalCredit: number | any,
	totalDebit: number | any,
	createdAt: string,
};

interface UserWalletDetailsProps {
	showModal: boolean;
	onHide: () => void;
	userId: string;
	formatAmount: (amount: number) => string;
	capitalizeFirstLetter: (string: string) => string;
};

const UserWalletDetails = ({ showModal, onHide, userId, formatAmount, capitalizeFirstLetter }: UserWalletDetailsProps) => {

	const [walletDetail, setWalletDetail] = useState<Wallet | null>(null);
	const [showWalletActivities, setShowWalletActivities] = useState(false);
	const [showDebitForm, setShowDebitForm] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		const fetchWalletDetails = async () => {
			setIsLoading(true);
			try {
				api.setAuthorization(api.getLoggedInUser());
				const response = await api.get(endpoints.getWalletDetails(userId), {});
				setWalletDetail(response.data.data);
				setIsLoading(false);
			} catch (error) {
				console.error("Error fetching book", error);
				setIsLoading(false);
			} finally {
				setIsLoading(false);
			}
		};
		if (userId) {
			fetchWalletDetails();
		}
	}, [userId]);

	const formatDate = (dateString: moment.MomentInput) => {
		return moment(dateString).format("DD of MMMM, YYYY");
	};

	const handleOpenWalletActivities = () => {
		setShowWalletActivities(true)
	}

	const [checked, setChecked] = useState(false);
	const handleToggle = (e: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
		setChecked(e.target.checked);
	};

	const hideDebitForm = () => {
		setShowDebitForm(false);
	}


	return (
		<>
			<div className="modal-backdrop" onClick={onHide}></div>
			<div className="modal-container">
				<div className="book-details-body">
					<div className="custom-modal-header">
						{!showDebitForm ? (
							<>
								<h4>User Wallet</h4>
								<Button className="view-activities" onClick={handleOpenWalletActivities}>View Activities</Button>
							</>
						) : (
							<>
								<img src={backBtn} alt="back" onClick={hideDebitForm} style={{ cursor: 'pointer' }} />
								<h4>Debit Wallet</h4>
							</>
						)}
					</div>
					{isLoading ? (
						<div className="spinner-div">
							<Spinner animation="border" size="sm" role="status" />
						</div>
					) : (
						<div className="custom-modal-body">
							<div className="detail-section">
								<div className="detail-section-name">
									<div className="detail-name-email">
										<span className="name">{`${walletDetail?.user?.firstName} ${walletDetail?.user?.lastName}`}</span> <br />
										<span className="email">{walletDetail?.user?.email}</span>
									</div>
									<span className="type">{capitalizeFirstLetter(walletDetail?.userType)}</span>
								</div>
								<div className="wallet-card mt-4 mb-4">
									<div className="wallet-card-inner">
										<div className="card-inner-top">
											<span>Active Balance</span>
											<img src={mastercardImg} alt="mastercard" />
										</div>
										<p>{formatAmount(walletDetail?.balance)}</p>
										<span>{`${walletDetail?.user?.firstName} ${walletDetail?.user?.lastName}`}</span>
									</div>
								</div>
								<Button onClick={() => setShowDebitForm(true)}>Debit Wallet</Button>
							</div>

							{showDebitForm && (
								<DebitWallet
									formatAmount={formatAmount}
									walletDetail={walletDetail}
									hideDebitForm={hideDebitForm}
								/>
							)}

							{!showDebitForm && (
								<>
									<div className="detail-section">
										<Card className="wallet-inflow-card mb-4">
											<Card.Body>
												<Card.Title>Total Inflow</Card.Title>
												<Card.Text className="total-flow">{formatAmount(walletDetail?.totalCredit)}</Card.Text>
											</Card.Body>
										</Card>
										<Card className="wallet-outflow-card">
											<Card.Body>
												<Card.Title>Total Outflow</Card.Title>
												<Card.Text className="total-flow">{formatAmount(walletDetail?.totalDebit)}</Card.Text>
											</Card.Body>
										</Card>
									</div>
									<div className="detail-section">
										<div className="book-detail">
											<span>Institution</span>
											<p>{walletDetail?.user?.institution}</p>
										</div>
										<div className="book-detail">
											<span>Department</span>
											<p>{walletDetail?.user?.department}</p>
										</div>
									</div>
									<div className="detail-section">
										<div className="book-detail">
											<span>Created On</span>
											<p>{formatDate(walletDetail?.createdAt)}</p>
										</div>
									</div>
									<div>
										<b>Status</b>
										<div style={{ display: 'flex', justifyContent: 'space-between' }}>
											<span>Click to enable or disable a wallet</span>
											<Form.Check
												type="switch"
												id="custom-switch"
												label={checked ? 'On' : 'Off'}
												checked={checked}
												onChange={handleToggle}
											/>
										</div>
									</div>
								</>
							)}
						</div>
					)}
				</div>
			</div>

			{showWalletActivities && (
				<div className="user-wallet-activities">
					<UserWalletActivities
						userId={userId}
						onHide={() => setShowWalletActivities(false)}
						formatAmount={formatAmount}
						walletDetail={walletDetail}
					/>
				</div>
			)}
		</>
	)
}

export default UserWalletDetails;